import {
  ModalWrapper,
  ModalDisplayer,
  AnimatedBackground
} from "./Styles";

import MikeLogo from "../../Assets/logo.png";
import { useEffect } from "react";

export const Modal = ({
  children,
  isOpen,
  onClose,
  fullScreen = true
}:{
  children: React.ReactNode,
  isOpen: boolean,
  onClose?: () => void,
  /** When false, the overlay leaves the nav sidebar visible and usable */
  fullScreen?: boolean
}) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    };

    let didModifyOverflow = false;
    const originalOverflow = document.body.style.overflow;

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
      didModifyOverflow = true;
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      if (didModifyOverflow) {
        document.body.style.overflow = originalOverflow || "unset";
      }
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <ModalWrapper $isOpen={isOpen} $fullScreen={fullScreen} onClick={(e) => {
      if (e.target === e.currentTarget && onClose) {
        onClose();
      }
    }}>
      <AnimatedBackground>
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
      </AnimatedBackground>
      <img src={MikeLogo} alt="logo" />
      <ModalDisplayer onClick={(e) => e.stopPropagation()}>
        {children}
      </ModalDisplayer>
    </ModalWrapper>
  )
};